var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.57735C18.1188 0.220085 18.8812 0.220085 19.5 0.57735L33.5215 8.67265C34.1403 9.02991 34.5215 9.69017 34.5215 10.4047L34.5215 26.5953C34.5215 27.3098 34.1403 27.9701 33.5215 28.3274L19.5 36.4226C18.8812 36.7799 18.1188 36.7799 17.5 36.4226L3.47853 28.3274C2.85973 27.9701 2.47853 27.3098 2.47853 26.5953L2.47853 10.4047C2.47853 9.69017 2.85973 9.02991 3.47853 8.67265L17.5 0.57735Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 6.01036C18.2141 5.74241 18.7859 5.74241 19.25 6.01036L28.9413 11.6057C29.4054 11.8736 29.6913 12.3688 29.6913 12.9047L29.6913 24.0953C29.6913 24.6312 29.4054 25.1264 28.9413 25.3943L19.25 30.9896C18.7859 31.2576 18.2141 31.2576 17.75 30.9896L8.05866 25.3943C7.59456 25.1264 7.30866 24.6312 7.30866 24.0953L7.30866 12.9047C7.30866 12.3688 7.59456 11.8736 8.05866 11.6057L17.75 6.01036Z",
    stroke: "#00FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 11.0104C18.2141 10.7424 18.7859 10.7424 19.25 11.0104L24.6112 14.1057C25.0753 14.3736 25.3612 14.8688 25.3612 15.4047L25.3612 21.5953C25.3612 22.1312 25.0753 22.6264 24.6112 22.8943L19.25 25.9896C18.7859 26.2576 18.2141 26.2576 17.75 25.9896L12.3888 22.8943C11.9247 22.6264 11.6388 22.1312 11.6388 21.5953L11.6388 15.4047C11.6388 14.8688 11.9247 14.3736 12.3888 14.1057L17.75 11.0104Z",
    stroke: "#00FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9689 17.0387L18.5 15.5774L21.0311 17.0387L21.0311 19.9613L18.5 21.4226L15.9689 19.9613L15.9689 17.0387Z",
    stroke: "#00FFFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 3,
    width: 3,
    height: 11,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 19.2207,
    width: 3,
    height: 11,
    transform: "rotate(59.6224 14.25 19.2207)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 11,
    transform: "matrix(-0.554188 0.832392 0.832392 0.554188 23.4258 19.3945)",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 -1.10909e-09 -1.10909e-09 1 20 2)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 26,
    r: 1,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "matrix(-1 -1.10909e-09 -1.10909e-09 1 33 26)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBoxLogo);
export default __webpack_public_path__ + "static/media/footer-box-logo.ac9f114513884d469b3b11e274cfabdc.svg";
export { ForwardRef as ReactComponent };